import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import App from "./App";
import "./index.scss";
import { SocketProvider } from "./context/SocketContext";
import { NotificationProvider } from "./context/NotificationContext";
import { installApiLanguageHeader } from "./i18n/apiLanguageHeader";
import { installSyncGuard } from "./utils/syncGuard";
import { installOfflineSupport } from "./offline/offlineSync";
import SyncConflictNotice from "./components/SyncConflictNotice/SyncConflictNotice";
import SyncStatus from "./components/SyncStatus/SyncStatus";

// The language header goes underneath both, so it is on every API request
// (also the ones the offline sync sends later)
installApiLanguageHeader();

// Offline support goes underneath the sync guard, so the guard's update
// requests can be queued while offline
installOfflineSupport();
installSyncGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <SocketProvider>
      <NotificationProvider>
        <App />
        <SyncConflictNotice />
        <SyncStatus />
      </NotificationProvider>
    </SocketProvider>
  </BrowserRouter>,
);
